import { AbstractCustomField } from '@/components/Fields/dataObjects/AbstractCustomField'
import { CustomFieldCustomFieldOptionInput, CustomFieldType } from '@/gql/graphql'

export class FreeText extends AbstractCustomField {
  fieldType: CustomFieldType = CustomFieldType.FreeText

  optionsForGraphQL(): CustomFieldCustomFieldOptionInput[] {
    // Free text does not have options
    return []
  }
}
